export default {
  destroyed() {
    this.$store.commit('socialBoostCampaign/CLEAR_CAMPAIGN_FORM')
    this.$store.commit('socialBoostCampaign/SET_CAMPAIGN', false)
    this.$store.commit('socialBoostCampaign/SET_FLIGHT', false)
  },
}
